import React from "react";
import { Link } from "react-router-dom";

function Index(props) {
  const settingsCards = [
    {
      title: "Website Structuur",
      description: "Beheer de hiërarchische structuur van uw website",
      icon: "fas fa-sitemap",
      link: "/cms/settings/website",
      color: "primary"
    },
    {
      title: "Talen",
      description: "Configureer meertalige instellingen en vertalingen",
      icon: "fas fa-language",
      link: "/cms/settings/talen",
      color: "success"
    },
    {
      title: "Media",
      description: "Beheer media instellingen en bestandstypen",
      icon: "fas fa-images",
      link: "/cms/settings/media",
      color: "warning"
    },
    {
      title: "Pagina Onderdelen",
      description: "Definieer herbruikbare pagina componenten",
      icon: "fas fa-puzzle-piece",
      link: "/cms/settings/onderdelen",
      color: "info"
    },
    {
      title: "AI Contentstijl-gids",
      description: "Stel richtlijnen in voor AI-gegenereerde content",
      icon: "fas fa-robot",
      link: "/cms/settings/ai-contentstijl",
      color: "secondary"
    }
  ];

  return (
    <div className="content-page">
      <div className="modern-cms-settings">
        <div className="settings-content">
          {/* Header */}
          <div className="settings-header">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h1>
                  <i className="fas fa-cogs me-3"></i>
                  CMS Instellingen
                </h1>
                <p>
                  Configureer en beheer alle aspecten van uw content management systeem
                </p>
              </div>
            </div>
          </div>

          {/* Settings Overview Cards */}
          <div className="row">
            {settingsCards.map((setting, index) => (
              <div key={index} className="col-lg-6 col-xl-4">
                <Link to={setting.link} className="text-decoration-none">
                  <div className={`card h-100 settings-card border-${setting.color}`}>
                    <div className="card-body text-center">
                      <div className={`settings-icon-container bg-${setting.color} mb-3`}>
                        <i className={`${setting.icon} text-white`}></i>
                      </div>
                      <h5 className="card-title text-dark">
                        {setting.title}
                      </h5>
                      <p className="card-text text-muted">
                        {setting.description}
                      </p>
                      <div className="mt-auto">
                        <span className={`btn btn-outline-${setting.color} btn-sm`}>
                          <i className="fas fa-arrow-right me-1"></i>
                          Configureren
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          {/* Quick Actions */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5>
                    <i className="fas fa-bolt me-2"></i>
                    Snelle Acties
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="d-grid">
                        <Link to="/cms/content" className="btn btn-outline-primary">
                          <i className="fas fa-edit me-2"></i>
                          Content Beheren
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="d-grid">
                        <Link to="/cms/types" className="btn btn-outline-success">
                          <i className="fas fa-layer-group me-2"></i>
                          Component Builder
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="d-grid">
                        <Link to="/cms/media" className="btn btn-outline-info">
                          <i className="fas fa-photo-video me-2"></i>
                          Media Library
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* System Info */}
          <div className="row">
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h5>
                    <i className="fas fa-info-circle me-2"></i>
                    Systeeminformatie
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-item mb-3">
                        <small className="text-muted">CMS Versie</small>
                        <div className="fw-semibold">RecraPlan CMS v2.0</div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="info-item mb-3">
                        <small className="text-muted">Laatste Update</small>
                        <div className="fw-semibold">{new Date().toLocaleDateString('nl-NL')}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h5>
                    <i className="fas fa-question-circle me-2"></i>
                    Hulp & Ondersteuning
                  </h5>
                </div>
                <div className="card-body">
                  <p className="text-muted mb-3">
                    Heeft u vragen over de CMS instellingen?
                  </p>
                  <div className="d-flex gap-2">
                    <button className="btn btn-outline-primary btn-sm">
                      <i className="fas fa-book me-1"></i>
                      Documentatie
                    </button>
                    <button className="btn btn-outline-success btn-sm">
                      <i className="fas fa-life-ring me-1"></i>
                      Support
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
